import { Box } from '@chakra-ui/react';
import usePipelineStore from '../../../../stores/pipeline-store';

type FinishStepSettingProps = {
    stepId: string;
};

export function FinishStepSettings({ stepId }: FinishStepSettingProps) {
    const { pipeline } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as FinishStep;

    return <Box mx={-3}></Box>;
}
